import { memo } from 'react';
import Image from 'next/legacy/image';

import { Container, Link, NextLink } from '@/atoms';

import { formatGiveawayDate, removeBaseURL } from '@/lib/utils';
import Button from '../button';

import type { FunctionComponent } from 'react';
import type { TypeCardGiveawayProps } from './types';

/**
 * CardGiveaway
 */
export const CardGiveaway: FunctionComponent<TypeCardGiveawayProps> = ({
  title,
  initDate,
  endDate,
  description,
  image,
  link,
}: TypeCardGiveawayProps): JSX.Element => (
  <Container
    className="w-full max-w-[385px] gap-y-4 border border-primary-200"
    padding="p-4 md:p-6"
    justify="justify-start"
    align="items-start"
    backgroundColor="bg-bg-secondary"
  >
    {image && (
      <div className="relative h-48 w-full">
        <Image
          src={image.sourceUrl}
          alt={image?.altText || title}
          layout="fill"
          objectFit="cover"
        />
      </div>
    )}

    {title && (
      <h3 className="u-headline u-headline--h3 text-primary-900">{title}</h3>
    )}

    {initDate && endDate && (
      <p className="u-label u-label--overlline text-primary-900">
        {formatGiveawayDate(initDate, endDate)}
      </p>
    )}

    {description && (
      <p className="u-body u-body--m line-clamp-4 text-primary-600">
        {description}
      </p>
    )}

    {link && (
      <div className="mt-auto flex items-center gap-x-4">
        <NextLink href={`/sorteos/${removeBaseURL(link)}` || '/'} passHref>
          <Button as="a" variant="primary">
            PARTICIPA
          </Button>
        </NextLink>

        <NextLink
          href={`/sorteos/${removeBaseURL(link)}?bases=true` || '/'}
          passHref
        >
          <Link size="large" type="secondary">
            Ver bases
          </Link>
        </NextLink>
      </div>
    )}
  </Container>
);

export default memo(CardGiveaway);
